import { getContext, setContext } from "svelte"
import { writable } from "svelte/store"

/**
 * @typedef {{
 *   projectId: string,
 *   project: any,
 *   executionId: string,
 * }} AutoMpsProjectContextValueType
 */

/**
 * @type {AutoMpsProjectContextValueType}
 */
const defaultAutoMpsProjectContextValue = {
  projectId: "",
  project: null,
  executionId: "",
}

const createAutoMpsProjectContextValueStore = (initialValues) => {
  return writable(initialValues ?? defaultAutoMpsProjectContextValue)
}

const autoMpsProjectContextSymbol = Symbol("autoMpsProject")

export function getAutoMpsProjectContext() {
  return getContext(autoMpsProjectContextSymbol)
}

/**
 *
 * @param {AutoMpsProjectContextValueType} [autoMpsProjectContextValue]
 */
export function setAutoMpsProjectContext(autoMpsProjectContextValue) {
  const store = createAutoMpsProjectContextValueStore(autoMpsProjectContextValue)
  setContext(autoMpsProjectContextSymbol, store)
  return store
}
